module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/hairstyle_makeup-01e33def65ce7070f6f971157144ce89.webp";